import _ from 'lodash';
import jQuery from 'jquery';
import moment from 'moment';

/**
 * Scripts that need to run at each pageload
 */
jQuery(document).ready(() => {
  // Enable (menu) dropdowns
  jQuery('.dropdown-toggle').dropdown();
});

/**
 * Replace all .relative-date with their moment counterpart
 * and set the title to their previously show date.
 */
_.each(document.querySelectorAll('.relative-date'), (date) => {
  date.title = date.innerText.trim();
  date.innerText = moment.utc(date.title, 'YYYY-MM-DD hh:mm:ss').fromNow();
});



// WEBPACK FOOTER //
// ./resources/assets/js/init.js